export default {"src":"/_next/static/media/Community.607d43e7.svg","height":465,"width":510,"blurWidth":0,"blurHeight":0};